<div class="quote-details-container">
  <div class="row col-12 col-sm-12 manage-user-container quote-container">
    <div class="col-3 col-sm-3 left-side">
      <app-my-account-left-sidenav [navState]="'MyQuotesNavNode'"
      [childNavState]="'MyQuotesNavNode'"></app-my-account-left-sidenav>
    </div>

    @if (quoteDetails) {
      <div class="myAccountMyProfile col-9 col-sm-9 right-side">
        <div class="my-section-box">
          <div class="my-section-box__headline">
          {{'common.text_account_quote_myquotes'|cxTranslate}}</div>
          <div class="my-section-box-inner">
            <div class="order-detail-overview">
              <div class="row">
                <div class="col-sm-12 col-md-9">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="item-group d-flex flex-column">
                        <span class="item-label">{{'common.text_account_quote_page_sort_byCode'|cxTranslate}}</span>
                        <span class="item-value">{{quoteDetails.code}}</span>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="item-group d-flex flex-column">
                        <span class="item-label">Version</span>
                        <span class="item-value">{{quoteDetails.version}}</span>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="item-group d-flex flex-column">
                        <span class="item-label">{{'common.text_account_quote_status'|cxTranslate}}</span>
                        <span class="item-value">{{quoteDetails.quoteState.name}}</span>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="item-group d-flex flex-column">
                        <span class="item-label">{{'common.text_account_quote_date_updated'|cxTranslate}}</span>
                        <span class="item-value">{{formatDate(quoteDetails.updatedTime)}}</span>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="item-group d-flex flex-column">
                        <span class="item-label">{{'common.text_account_quote_date_placed'|cxTranslate}}</span>
                        <span class="item-value">{{formatDate(quoteDetails.creationTime)}}</span>
                      </div>
                    </div>
                    <div class="col-sm-12 myQuote-bottomDetail">
                      <div class="item-group">
                        <span class="item-label">{{'common.text_quote_name_label'|cxTranslate}}</span>
                        <span class="item-value">{{quoteDetails.name}}</span>
                      </div>
                    </div>
                    <div class="col-sm-12 myQuote-bottomDetail">
                      <div class="item-group">
                        <span class="item-label">{{'common.text_quote_description_label'|cxTranslate}}</span>
                        <span class="item-value">
                        {{quoteDetails.description}}</span>
                      </div>
                    </div>
                    <div class="col-sm-12 myQuote-bottomDetail">
                      <div class="item-group">
                        <span class="item-label">{{'common.text_quote_previous_estimated_total_display'|cxTranslate}}</span>
                        <span class="item-value">{{quoteDetails?.previousEstimatedTotal?.formattedValue}}&nbsp;
                        {{quoteDetails?.previousEstimatedTotal?.currencyIso}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3">
                  <div class="item-action">
                    @if (isCancelAllowed) {
                      <button type="button" class="btn btn-default btn-block item__btn cancel-btn js-quote-cancel-btn" (click)="openDialogBox(false)">
                      {{'common.text_account_quote_action_display_CANCEL'|cxTranslate}}</button>
                    }
                    @if (isSubmitAllowed) {
                      <button type="submit" class="btn btn-primary btn-block re-order item__btn blue-btn js-quote-submit-btn" (click)="openDialogBox(true)" id="submitQuoteButton">
                      {{'common.text_account_quote_action_display_SUBMIT'|cxTranslate}}</button>
                    }
                    <div>
                    </div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (quoteDetails.entries.length>0) {
            <div class="cart-items">
              <ul class="item__list item__list__cart">
                <li class="d-none d-sm-none d-md-block">
                  <ul class="item__list--header">
                    <li class="item__toggle"></li>
                    <li class="item__image"></li>
                    <li class="item__info">{{'common.basket_page_item'|cxTranslate}}</li>
                    <li class="item__price">{{'common.text_quickOrder_page_price'|cxTranslate}}</li>
                    <li class="item__quantity">{{'common.basket_page_qty'|cxTranslate}}</li>
                    <li class="item__total">{{'common.basket_page_totals_total'|cxTranslate}}</li>
                    <li class="item__menu "></li>
                  </ul>
                </li>
                @for (item of quoteDetails.entries; track item) {
                  <li class="item__list--item d-flex align-items-center">
                    <div class="d-none d-sm-none d-md-block item__toggle">
                    </div>
                    <div class="thumb">
                      <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl" tabindex="0">
                        <cx-media
                          [container]="item.product?.images?.['PRIMARY'] || item.product?.images">
                        </cx-media>
                      </a>
                    </div>
                    <div class="item__info">
                      <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl"><span class="item__name">{{item.product.description}}</span></a>
                      <div class="item__code">
                      {{item.product.code}}</div>
                    </div>
                    <div class="item__price">
                      <span class="d-block d-sm-block d-md-none">{{'common.basket_page_itemPrice'|cxTranslate}}:</span>
                    {{item.basePrice.formattedValue}}&nbsp;{{item.basePrice.currencyIso}}</div>
                    <div class="item__quantity d-none d-sm-none d-md-block">
                      <label class="d-block d-sm-block d-md-none">{{'common.basket_page_qty'|cxTranslate}}:</label>
                      <span class="qtyValue">{{item?.formattedQuantity}}</span>
                    </div>
                    <div class="item__total d-none d-sm-none d-md-block">
                    {{item.totalPrice.formattedValue}}&nbsp;{{item.totalPrice.currencyIso}}</div>
                    <div class="item__quantity__total d-block d-sm-block d-md-none">
                      <div class="details " data-index="0">
                        <div class="qty">
                          <label>{{'common.basket_page_qty'|cxTranslate}}:</label>
                          <span class="qtyValue">{{item?.formattedQuantity}}</span>
                          <div class="item__total">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="item__menu">
                      <img class="close-icon" src="/icons/close.svg" (click)="deleteEntries(item)">
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
          <div class="account-orderdetail">
            <div class="account-orderdetail__footer">
              <div class="row">
                <div class="col-sm-6 col-md-7 col-lg-8">
                </div>
                <div class="col-sm-6 col-md-5 col-lg-4">
                  <div class="orderTotal">
                    <div class="row">
                      <div class="col-sm-6">
                      {{'common.basket_page_totals_subtotal'|cxTranslate}}</div>
                      <div class="col-sm-6">
                        <div class="text-right">
                          {{quoteDetails.subTotal.formattedValue}}&nbsp;
                        {{quoteDetails.subTotal.currencyIso}}</div>
                      </div>
                      <div class="col-sm-6">
                        <div class="totals">
                        {{'common.text_account_order_orderTotals'|cxTranslate}}</div>
                      </div>
                      <div class="col-sm-6 text-right">
                        <div class="totals">
                          {{quoteDetails.totalPrice.formattedValue}}&nbsp;
                        {{quoteDetails.totalPrice.currencyIso}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="cart-totals-taxes text-right">
                  {{'common.basket_page_totals_noNetTax'|cxTranslate}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>